import { createSlice } from '@reduxjs/toolkit';
import { createExtraReducersForThunk, createApiThunkPrivate } from '../_helpers/ApiThunk';

const initialState = {
    getDashboardCountData: {}, getDashboardTotalSaleData: {}, getDashboardOrderListData: {}, getDashboardOrderChartData: {}, getDesignerDashboardCountData: {},
    // Super Admin Dashboard v2 state slices (one per new /admin-dashboard endpoint)
    getOverviewData: {},
    getSalesTrendData: {},
    getRevenueBySourceData: {},
    getTopDesignersData: {},
    getOrdersByStatusData: {},
    getBestSellingProductsData: {},
    getLowInventoryAlertsData: {},
    getRecentOrdersData: {},
    getReturnsRefundsData: {},
    getPendingPayoutsData: {},
    getAlertsSummaryData: {},
    getActiveDesignersData: {},
}

export const getDashboardCount = createApiThunkPrivate('getDashboardCount', '/admin-dashboard/totalCount', 'GET')
export const getDashboardTotalSale = createApiThunkPrivate('getDashboardTotalSale', '/admin-dashboard/total-sale', 'GET')
export const getDashboardOrderList = createApiThunkPrivate('getDashboardOrderList', '/admin-dashboard/order-list', 'GET')
export const getDashboardOrderChart = createApiThunkPrivate('getDashboardOrderChart', '/admin-dashboard/order-chart', 'GET')

export const getDesignerDashboardCount = createApiThunkPrivate('getDesignerDashboardCount', '/admin-dashboard/counts', 'GET')

// Super Admin Dashboard v2 thunks — all GET with query params (startDate,
// endDate, and per-endpoint limit/granularity), dispatched e.g.
// dispatch(getOverview({ startDate, endDate })). createApiThunkPrivate
// forwards non-body payloads as `params` for GET requests (see ApiThunk.js).
export const getOverview = createApiThunkPrivate('getOverview', '/admin-dashboard/overview', 'GET')
export const getSalesTrend = createApiThunkPrivate('getSalesTrend', '/admin-dashboard/sales-trend', 'GET')
export const getRevenueBySource = createApiThunkPrivate('getRevenueBySource', '/admin-dashboard/revenue-by-source', 'GET')
export const getTopDesigners = createApiThunkPrivate('getTopDesigners', '/admin-dashboard/top-designers', 'GET')
export const getOrdersByStatus = createApiThunkPrivate('getOrdersByStatus', '/admin-dashboard/orders-by-status', 'GET')
export const getBestSellingProducts = createApiThunkPrivate('getBestSellingProducts', '/admin-dashboard/best-selling-products', 'GET')
export const getLowInventoryAlerts = createApiThunkPrivate('getLowInventoryAlerts', '/admin-dashboard/low-inventory-alerts', 'GET')
export const getRecentOrders = createApiThunkPrivate('getRecentOrders', '/admin-dashboard/recent-orders', 'GET')
export const getReturnsRefunds = createApiThunkPrivate('getReturnsRefunds', '/admin-dashboard/returns-refunds', 'GET')
export const getPendingPayouts = createApiThunkPrivate('getPendingPayouts', '/admin-dashboard/pending-payouts', 'GET')
export const getAlertsSummary = createApiThunkPrivate('getAlertsSummary', '/admin-dashboard/alerts-summary', 'GET')
export const getActiveDesigners = createApiThunkPrivate('getActiveDesigners', '/admin-dashboard/active-designers', 'GET')



const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    extraReducers: builder => {
        createExtraReducersForThunk(builder, getDashboardCount, 'getDashboardCountData')
        createExtraReducersForThunk(builder, getDashboardTotalSale, 'getDashboardTotalSaleData')
        createExtraReducersForThunk(builder, getDashboardOrderList, 'getDashboardOrderListData')
        createExtraReducersForThunk(builder, getDashboardOrderChart, 'getDashboardOrderChartData')
        createExtraReducersForThunk(builder, getDesignerDashboardCount, 'getDesignerDashboardCountData')

        createExtraReducersForThunk(builder, getOverview, 'getOverviewData')
        createExtraReducersForThunk(builder, getSalesTrend, 'getSalesTrendData')
        createExtraReducersForThunk(builder, getRevenueBySource, 'getRevenueBySourceData')
        createExtraReducersForThunk(builder, getTopDesigners, 'getTopDesignersData')
        createExtraReducersForThunk(builder, getOrdersByStatus, 'getOrdersByStatusData')
        createExtraReducersForThunk(builder, getBestSellingProducts, 'getBestSellingProductsData')
        createExtraReducersForThunk(builder, getLowInventoryAlerts, 'getLowInventoryAlertsData')
        createExtraReducersForThunk(builder, getRecentOrders, 'getRecentOrdersData')
        createExtraReducersForThunk(builder, getReturnsRefunds, 'getReturnsRefundsData')
        createExtraReducersForThunk(builder, getPendingPayouts, 'getPendingPayoutsData')
        createExtraReducersForThunk(builder, getAlertsSummary, 'getAlertsSummaryData')
        createExtraReducersForThunk(builder, getActiveDesigners, 'getActiveDesignersData')
    }
})

export default dashboardSlice.reducer